<style lang="less" scoped>
/*@import "../../style/common.less";*/
@import "../../style/color.less";
@import "../../style/button.css";
/*@import "../../style/greenStyle.less";*/
/*@import "../../style/custom.less";*/
/*@import "../../style/components.less";*/
/*@import "../../style/uniform.default.min.less";*/

.flex-1 {
	flex: 1;
}

.flex-2 {
	flex: 2;
}

.date1 {
	width: 150px;
	height: 38px;
}

.fcc_bgpg{
	/*background: url("../../img/footer_logo_fcc.svg")no-repeat;*/
	/*z-index:1;*/
	/*background-position: 95%;*/
}

.formTable {
	float: left;
	margin-top: 10px;
	width: 80%;
	//width: 1300px;
	height: 150px;
	margin-bottom: 10px;
	/*border: 1px red solid;*/
	/*background: url("../../img/fccLOGO.png")no-repeat;*/
	/*background-position: 85%;*/
	/*border: 1px red solid;*/
}
.logoPG{
	width:20%;
	height:150px;
	float: right;
	margin-top: 10px;
	margin-bottom: 10px;
	/*border: 1px red solid;*/
	/*position: relative;*/
	/*right: 100px;*/
	/*bottom: 100px;*/
}

.like_instNo {
	float: left;
	width: 290px;
	height: 50px;
}
.like_date {
	float: left;
	width: 650px;
	height: 50px;
}

.firstRow {
	/*float: left;*/
	height: 50px;
	/*width: 80%;*/
	/*margin-bottom: 20px;*/
	/*width: 1000px;*/
}
.secondRow {
	float: left ;
	height: 50px;
	/*width: 80%;*/
	/*border: 1px black solid;*/
	margin-top: 10px;
	margin-bottom: 10px;
	/*width: 1000px;*/
}

.like_date {
	float: left;
	width: 450px;
	height: 50px;
}

.like_cust {
	float: left;
	width: 450px;
	height: 50px;
}

.min-320 {
	min-width: 320px;
}

.min-540 {
	min-width: 540px;
}
.min-520 {
	min-width: 500px;
}
.min-680 {
	min-width: 680px;
}

.min-220 {
	min-width: 220px;
}

.inline-block {
	display: inline-block;
}

.query-div-select {
	width: 150px;
}

.label-control {
	display: inline-block;
	font-size: 14px;
	font-weight: 700;
	color: yellowgreen;
}

/*.el-table {
	background: linear-gradient(to right, #092a9c, #0c5692) !important ;
}*/
.form-control {
	background-color: white !important;
}

span.query-title-span {
	display: inline-block;
	width: 90px;
	font-size: 14px;
	font-weight: 700;
	text-align: right;
	margin-right: 20px;
	color: black;
}

span.queryMust-title-span {
	display: inline-block;
	width: 90px;
	font-size: 14px;
	font-weight: 700;
	text-align: right;
	margin-right: 20px;
	color: red;
}

span.query-title-line {
	display: inline-block;
	font-size: 14px;
	font-weight: 700;
	text-align: center;
	width: 30px;
	color: yellowgreen;
}

/*.portlet.light{*/
/*	background: linear-gradient(to right, #092a9c, #0c5692) !important ;*/
/*}*/
.query-div-input-date {
	width: 150px;
}

.query-div {
	// border: 1px solid #ddd;
	padding: 16px 0;
	border-radius: 4px;
}

.margin-left-8 {
	margin-left: 8px;
}

.draw-enter-active, .draw-leave-active {
	transition: all 1s ease;
}

.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
	height: 0;
	overflow: hidden;
}

.uploadImg {
	width: 100%;
	height: 1.5rem;
	position: relative;

	input {
		width: 1.46rem;
		height: 100%;
		z-index: 1;
		opacity: 0;
		position: absolute;
		cursor: pointer;
	}
}
span.limitNum {
	display: inline-block;
	width: 280px;
	font-size: 17px;
	font-weight: 700;
	text-align: center;
	/*margin-left: 20px;*/
	color: black;
}
</style>
<style lang="less">
.dialog-input-text .el-input__inner {
	//width: 75px;
	width: 100%;
	height: 40px;
	border: 1px solid deepskyblue;
	font-weight: bold;
}
//数字靠右
.dialog-input-text2 .el-input__inner {
	//width: 75px;
	width: 100%;
	height: 40px;
	border: 1px solid deepskyblue;
	text-align: right;
}
.el-date-table{
	font-size: 18px;
}
.el-date-table tr td:first-child{
	color: #CE4040;
}
.el-date-table tr td:last-child{
	color: #8DEF56;
}
span.query-title-span1 {
	display: inline-block;
	width: 110px;
	font-size: 14px;
	font-weight: 700;
	text-align: right;
	margin-right: 20px;
	color: black;
}
</style>
<template>
	<div class="iot-vue-container">
		<!-- 标题组件 -->
		<!--		<div class="vue-header">-->
		<!--			<div class="vue-header-title-div">-->
		<!--				<span class="vue-header-title" @click="init()">&nbsp;&nbsp;{{ pageTitle }}</span>-->
		<!--			</div>-->
		<!--			<div class="vue-header-breadcrumb">-->
		<!--				&lt;!&ndash;<Breadcrumb>-->
		<!--					<BreadcrumbItem :to="{name:sysCfg.mainPage}">首页</BreadcrumbItem>-->
		<!--					<BreadcrumbItem>{{sysCfg.modules.null}}</BreadcrumbItem>-->
		<!--					<BreadcrumbItem :to="{name:sysCfg.tRealtimeFillin.name_en}">{{sysCfg.tRealtimeFillin.name}}</BreadcrumbItem>-->
		<!--			   </Breadcrumb>&ndash;&gt;-->
		<!--			</div>-->
		<!--		</div>-->
		<div class="vue-main">
			<div class="fcc_bgpg">
			<!--查询条件 -->
			<div class="formTable">
				<div class="firstRow">
				<div class="like_instNo">
					<span class="query-title-span">采购单号</span>
					<el-input type="text" style="width: 150px" v-model="queryParam.poNo"/>
				</div>
				<div class="like_date">
					<span class="query-title-span">采购单发行月</span>
					<el-date-picker value-format="yyyy-MM" type="month" class="query-div-select inline-block"
									v-model="queryParam.crtDtFrom" :editable="false" placeholder="选择月份">
					</el-date-picker>
					-
					<el-date-picker value-format="yyyy-MM" type="month" class="query-div-select inline-block"
									v-model="queryParam.crtDtTo" :editable="false" placeholder="选择月份">
					</el-date-picker>
				</div>
				<div class="like_instNo" v-if="insideFlg">
					<span class="query-title-span">供应商代码</span>
					<el-input v-if="disableFlg" type="text" style="width: 150px" v-model="queryParam.spplCd" disabled/>
					<el-input v-else type="text" style="width: 150px" v-model="queryParam.spplCd"/>
				</div>

				<div class="like_instNo" v-if="insideFlg">
					<span class="query-title-span">供应商名称</span>
					<el-input v-if="disableFlg" type="text" style="width: 150px" v-model="queryParam.spplNm" disabled/>
					<el-input v-else type="text" style="width: 150px" v-model="queryParam.spplNm"/>
				</div>
				</div>
				<div class="firstRow">
					<!--add by duan 20220303 start-->
					<div class="like_instNo" v-if="insideFlg">
						<span class="query-title-span">采购作成者</span>
						<el-input type="text" style="width: 150px" v-model="queryParam.purcUsrNm"/>
					</div>
					<!--add by duan 20220303 end-->
				<div class="like_instNo">
					<span class="query-title-span1">采购单未下载</span>
					<el-checkbox v-model="queryParam.poStatus" :true-label="'1'" :false-label="'0'"></el-checkbox>
				</div>
					<div class="like_instNo">
						<span class="query-title-span1">搬入传票未下载</span>
						<el-checkbox v-model="queryParam.deliveryStatus" :true-label="'1'" :false-label="'0'"></el-checkbox>
					</div>
				</div>

				<!--				<div class="firstRow">-->
			</div>
				<div class="logoPG">
					<!--<div class="logoPG">-->
						<img src="../../img/footer_logo_fcc.svg" width="140px" height="150px" style="margin-left: 10px"/>
					<!--</div>-->
				</div>
			<!--操作功能区 -->
				<div class="secondRow">
			<div class="actions-div  margin-bottom-10" >
				<!--<div class="btns-div margin-top-10">-->
					<!--<Button type="primary" class="button button-glow button-rounded button-action"-->
							<!--@click="checkForSave"><i class="fa fa-save"></i> 保存-->
					<!--</Button>-->
					<!--<el-dialog-->
						<!--title="保存"-->
						<!--:visible.sync="dialogVisibleSave"-->
						<!--width="30%">-->
						<!--<span>确认保存吗？</span>-->
						<!--<span slot="footer">-->
						<!--<el-button @click="dialogVisibleSave = false">取 消</el-button>-->
						<!--<el-button type="primary" @click="checkedSave">确 定</el-button>-->
					  <!--</span>-->
					<!--</el-dialog>-->
				<!--</div>-->
				<div class="pull-right margin-top-10">
					<!--搜索区 -->
					<Button type="primary" class="button button-glow button-rounded button-royal"
							v-loading.fullscreen.lock="fullscreenLoading" icon="ios-search" slot="append"
							@click="getList('query')">检索
					</Button>
				</div>
			</div>
				</div>
			<!--操作功能区 -->
			</div>
			<!--表格区-->
			<el-table :data="listData" ref="multipleTable" :row-style="rowStyle"
					  :cell-style="tableRowStyle" :header-cell-style="tableHeaderColor" border row-key="id"
					  :height="600">
				<el-table-column label="采购单" min-width="80" align="center">
					<template slot-scope="scope">
						<Button v-if="scope.row.poStatus=='0'" class="button button-glow button-rounded button-highlight"
								@click="beforePoDw(scope.row.poNo,scope.row.verNo)"><i class="fa fa-download fa-fw"></i> 下载
						</Button>
						<Button v-if="scope.row.poStatus=='1'" class="button button-glow button-rounded button-raised"
								@click="beforePoDw(scope.row.poNo,scope.row.verNo)"><i class="fa fa-download fa-fw"></i> 下载
						</Button>
					</template>
				</el-table-column>
				<el-table-column label="搬入传票" min-width="80" align="center">
					<template slot-scope="scope">
						<Button v-if="scope.row.deliveryStatus=='0' && scope.row.foreignFlg=='0'" class="button button-glow button-rounded button-primary"
								@click="beforeDelDw(scope.row.poNo,scope.row.verNo)"><i class="fa fa-download fa-fw"></i> 下载
						</Button>
						<Button v-if="scope.row.deliveryStatus=='1' && scope.row.foreignFlg=='0'" class="button button-glow button-rounded button-raised"
								@click="beforeDelDw(scope.row.poNo,scope.row.verNo)"><i class="fa fa-download fa-fw"></i> 下载
						</Button>
						<Button v-if="scope.row.foreignFlg=='1'" class="button  button-rounded "
						 disabled="disabled"><i class="fa fa-download fa-fw" ></i> 下载
						</Button>
					</template>
				</el-table-column>
				<el-table-column prop="poNo" label="采购单号" min-width="160">
				</el-table-column>
				<el-table-column prop="verNo" label="版本号" min-width="40">
				</el-table-column>
				<el-table-column prop="spplNm" label="供应商" min-width="160">
				</el-table-column>
				<el-table-column prop="purcUsrNm" label="采购作成者" min-width="100">
				</el-table-column>
				<el-table-column prop="poReadStatus" label="采购数据状态" min-width="100" v-if="insideFlg">
					<template slot-scope="scope">
						<span v-if="scope.row.poReadStatus=='0'">未查看</span>
						<span v-else>已查看</span>
					</template>
				</el-table-column>
<!--				<el-table-column prop="lastModifiedWhen" label="采购单发行日" min-width="160">-->
<!--				</el-table-column>-->
				<el-table-column prop="poIssueDt" label="采购单发行日" min-width="160">
				</el-table-column>
			</el-table>
			<!--表格区-->
			<!--分页区 -->
			<el-pagination class="iot-pagination" :current-page="pageParams.currentPage"
						   :page-sizes="sysCfg.pageParams.opts" @size-change="handleSizeChange"
						   @current-change="handlePageChange" :page-size="pageParams.pageSize"
						   :layout="sysCfg.pageParams.pageLayout" :total="pageParams.total">
			</el-pagination>
		</div>
	</div>
</template>
<script>
import config from '@/config/config.js';
import moment from 'moment';
import {mapActions} from "vuex";
import httpUtil from "../../utils/httpUtil";
import api from "../../config/apiConfig";
import axios from 'axios';

export default {
	data() {
		return {
			pageTitle: '采购信息一览',
			sysCfg: config,
			listData: [],
			pageParams: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			queryParam: {
				crtDtFrom:'',
				crtDtTo:'',
				spplCd:'',
				spplNm:'',
				pageNum: 0,
				pageSize: 10
			},
			searchVal: '',
			detailRouter: 'tRealtimeFillinDetail',
			fullscreenLoading: false,
			dialogVisibleSave: false,
			multipleSelection: [],
			disableFlg:false,
			insideFlg:false,
		};
	},
	methods: {
		...mapActions("tab", ["reflush"]),
		init() {
			var _this=this;
			// 数据初始化
			_this.searchVal = '';
			_this.queryParam.crtDtFrom = this.getThisMonth();
			_this.queryParam.crtDtTo = this.getThisMonth();
			var currUser = JSON.parse(_this.$cookie.get(_this.$config.cookies.currUser));
			if(currUser.userType=='1'){//自公司用户
				_this.insideFlg=true;
			}else if(currUser.userType=='2'){//供应商用户
				_this.queryParam.spplCd=currUser.spplCd;
				// _this.queryParam.spplNm=currUser.spplName;
				_this.disableFlg=true;
			}

		},
		// 获取默认时间
		getThisMonth() {
			var yearUnix = new Date().getFullYear();
			var monthUnix = new Date().getMonth();
			var now = new Date().setFullYear(yearUnix,monthUnix,1);
			return this.$util.toDate(now);
		},
		// 获取列表
		getList(val) {
			let idf = this.queryParam.crtDtFrom;
			let idt = this.queryParam.crtDtTo;
			// if (idf == null || idf == undefined || idf == '' || idt == null || idt == undefined || idt == '') {
			// 	this.$util.error("检索条件充填入库日期不能为空");
			// 	return;
			// }
			if (idf > idt) {
				this.$util.error("采购发行月（结束）不可小于采购发行月（开始）。");
				return;
			}
			if (val !== undefined) {
				this.pageParams.currentPage = 1;
			}
			var _this = this;
			_this.initQueryParam();
			this.fullscreenLoading = true;
			// console.log(_this.queryParam,"====2====query==");
			_this.$httpUtil.ajaxGet(this, _this.$api.tPurchase.getList, _this.queryParam, function (response) {
				_this.listData = response.data.data.content;

				if (_this.listData.length === 0 && _this.pageParams.currentPage > 1) {
					_this.pageParams.currentPage--;
					_this.getList();
				} else {
					_this.pageParams.total = response.data.data.totalElements;
					_this.fullscreenLoading = false;
				}
				//重新渲染table布局，解决fixed错位
				_this.$nextTick(() => {
					_this.$refs.multipleTable.doLayout();
				});
			});
		},
		// 初始化查询参数
		initQueryParam() {
			this.queryParam.pageNum = this.pageParams.currentPage - 1 >= 0 ? this.pageParams.currentPage - 1 : 0;
			this.queryParam.pageSize = this.pageParams.pageSize;
			// this.queryParam.startDate = this.startDate;
			// this.queryParam.endDate = this.endDate;
		},

		beforePoDw(po,verNo){
			let _this = this;
			let param={
				poNo:po,
				verNo:verNo,
			}
			_this.$httpUtil.ajaxGet(this, _this.$api.tPurchase.beforePoDw, param, function (response) {
				if (response.data.data.status=='1'){
					_this.$util.error2('文件已过期，请联系管理员');
				}else {
					_this.toPoExport(po,verNo);
				}
			});
		},

		//采购单下载
		toPoExport(po,verNo) {
			let _this = this;
			let url = this.$api.tPurchase.toPoExport;
			let param= {
				poNo: po,
				verNo:verNo,
			};
			const loading = this.$loading({
				lock: true,
				text: '正在加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			axios({
				method: 'get',
				url: url,
				params: param,
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
					'authorization': _this.$cookie.get('slash_token')
				},
				timeout: 60000,
				data: {},
				responseType: 'blob',
			}).then(response => {
				loading.close();
				console.log(response,'responsesssssss')
				_this.poDownload(response.data,po,verNo)
			}).catch((error) => {
				loading.close();
				_this.fullscreenLoading = false;
			})
		},
		//下载文件
		poDownload(data,po,verNo) {
			if (!data) {
				this.fullscreenLoading = false;
				return;
			}
			let url = window.URL.createObjectURL(new Blob([data], {
				type: 'application/octet-stream'
			}));
			let link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			var fileName = '采购单';
			// var date = this.$util.getNow("yyyyMMddHHmmss");
			link.setAttribute('download', fileName + '_' + po + '_' +verNo+ '.pdf');
			document.body.appendChild(link);
			link.click();
			this.fullscreenLoading = false;
		},

		beforeDelDw(po,verNo){
			let _this = this;
			let param={
				poNo:po,
				verNo:verNo,
			}
			_this.$httpUtil.ajaxGet(this, _this.$api.tPurchase.beforeDelDw, param, function (response) {
				if (response.data.data.status=='1'){
					_this.$util.error2('文件已过期，请联系管理员');
				}else {
					_this.toDelExport(po,verNo);
				}
			});
		},
		//搬入传票下载
		toDelExport(po,verNo) {
			let _this = this;
			let url = this.$api.tPurchase.toDelExport;
			let param= {
				poNo: po,
				verNo:verNo,
			};
			const loading = this.$loading({
				lock: true,
				text: '正在加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			axios({
				method: 'get',
				url: url,
				params: param,
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
					'authorization': _this.$cookie.get('slash_token')
				},
				timeout: 60000,
				data: {},
				responseType: 'blob',
			}).then(response => {
				loading.close();
				_this.delDownload(response.data,po,verNo)
			}).catch((error) => {
				loading.close();
				_this.fullscreenLoading = false;
			})
		},
		//下载文件
		delDownload(data,po,verNo) {
			if (!data) {
				this.fullscreenLoading = false;
				return;
			}
			let url = window.URL.createObjectURL(new Blob([data], {
				type: 'application/octet-stream'
			}));
			let link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			var fileName = '搬入传票';
			// var date = this.$util.getNow("yyyyMMddHHmmss");
			link.setAttribute('download', fileName + '_' + po +'_'+verNo+ '.pdf');
			document.body.appendChild(link);
			link.click();
			this.fullscreenLoading = false;
		},
		handlePageChange(val) {
			this.pageParams.currentPage = val;
			this.getList();
		},
		handleSizeChange(val) { // 条数变更回调
			this.pageParams.pageSize = val;
			this.getList();
		},


		//设置表格行的样式
		tableRowStyle({row, column, rowIndex, columnIndex}) {
			return "border: 1px solid black !important;color:black;font-size:16px;padding: 7px 0;"
		},
		//设置表头行的样式
		tableHeaderColor({row, column, rowIndex, columnIndex}) {
			return 'border: 1px solid black !important; font-wight:500;font-size:15px;text-align:center;background-color: #CCCCCC !important;color:black;padding: 7px 0;'
		},
		//保存选中结果
		// handleSelectionChange(val) {
		// 	this.multipleSelection = val;
		// },
		rowStyle({row, rowIndex}){
			let arr = this.multipleSelection;
			if (arr!=null&&arr.length>0) {
				for(let i = 0; i < arr.length; i++){
					if( row.id == arr[i].id){
						return { "background-color": "rgba(0, 250, 154, 0.75)" };
					}
				}
			}
		},
	},
	mounted() {
		this.init();

	},
	watch: {}
};
</script>





// WEBPACK FOOTER //
// src/views/tPurchase/List.vue